import React from "react";
import ShareIcon from "@mui/icons-material/Share";
import { Button, Card, Col } from "react-bootstrap";
import Buseton from "../assets/img/BusetonOpcion1.jpeg";
import Bus from "../assets/img/Bus.jpg";
import Buseta from "../assets/img/Buseta.jpeg";
import Mercedes from "../assets/img/Van.jpeg";
import Micronissan from "../assets/img/MicroNissan.jpeg";
import "./VehiculoCard.css";

const imagenesVehiculos = {
  BUSETON: Buseton,
  BUS: Bus,
  BUSETA: Buseta,
  MERCEDES: Mercedes,
  "MICRO NISSAN URVAN ESCOLAR": Micronissan,
};

const VehiculoCard = ({ vehiculo, index = 0 }) => (
  <Col md={4} className="mb-4 vehiculo-card-col" style={{ animationDelay: `${index * 0.08}s` }}>
    <Card className="shadow-sm h-100 vehiculo-card">
      <div className="vehiculo-card-img-wrap">
        <Card.Img
          variant="top"
          src={imagenesVehiculos[vehiculo.tipo]}
          alt={`Imagen de ${vehiculo.tipo}`}
        />
      </div>
      <Card.Body>
        <Card.Title>{vehiculo.tipo}</Card.Title>
        <Card.Text>
          Capacidad: {vehiculo.capacidad} pasajeros <br />
          Precio: ${vehiculo.valor_base_un_dia}
        </Card.Text>
        <Button
          variant="primary"
          onClick={() => alert(`Compartir ${vehiculo.tipo}`)}
          className="d-inline-flex align-items-center gap-1"
        >
          Cotizar <ShareIcon fontSize="small" />
        </Button>
      </Card.Body>
    </Card>
  </Col>
);

export default VehiculoCard;
